import {
  GET_ALL_LITERACTURE_QUERY,
} from '../types'

const INITIAL_STATE = {
  allLiteractureQuery: [],
  getOneLiteractureQuery:{},
}

const LiteractureQueryReducer = (state = INITIAL_STATE, { type, payload }) => {
  switch (type) {
    case GET_ALL_LITERACTURE_QUERY:
      return {
        ...state,
        allLiteractureQuery: payload.data,
      }
    // case GET_ALL_GENERAL:
    //   return {
    //     ...state,
    //     getOneLiteractureQuery: payload.data,
    //   }
    default:
      return state
  }
}

export default LiteractureQueryReducer
